module.exports = __webpack_public_path__ + "img/mw.821bfec1.svg";